<form
  class="update-record-dialog"
  [formGroup]="hotkeyForm"
  (ngSubmit)="createHotkey()"
>
  <section class="record-summary" aria-label="Hotkey context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-bolt"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">New Hotkey</span>
      <h2>{{ hotkeyForm.get('hotkey_main')?.value || 'Hotkey details' }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Hotkey details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="hotkeyMain">Main Hotkey</label>
        <input
          id="hotkeyMain"
          pInputText
          type="text"
          formControlName="hotkey_main"
          maxlength="6"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('hotkey_main')?.hasError('required') && (hotkeyForm.get('hotkey_main')?.touched || hotkeyForm.get('hotkey_main')?.dirty)"
        >
          <strong>A main hotkey</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('hotkey_main')?.hasError('maxlength')"
        >
          Main hotkey must be 6 characters or fewer
        </small>
      </div>

      <div class="form-field">
        <label for="mainDescription">Hotkey Description</label>
        <input
          id="mainDescription"
          pInputText
          type="text"
          formControlName="main_description"
          maxlength="30"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('main_description')?.hasError('required') && (hotkeyForm.get('main_description')?.touched || hotkeyForm.get('main_description')?.dirty)"
        >
          <strong>A hotkey description</strong> is required
        </small>
        <small
          class="p-error"
          *ngIf="hotkeyForm.get('main_description')?.hasError('maxlength')"
        >
          Description must be 30 characters or fewer
        </small>
      </div>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <div>
        <h3>Tags</h3>
        <span>{{ tagsArray.length }} linked</span>
      </div>

      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Add tag"
        class="p-button-sm p-button-outlined"
        (click)="addTag()"
      ></button>
    </div>

    <div class="jobs-list" formArrayName="tags" *ngIf="tagsArray.length; else noTags">
      <article
        class="job-card"
        *ngFor="let tag of tagsArray.controls; index as i"
        [formGroupName]="i"
      >
        <div class="job-card__header">
          <span>Tag {{ i + 1 }}</span>

          <button
            pButton
            type="button"
            icon="pi pi-trash"
            label="Remove"
            class="p-button-sm p-button-text p-button-danger"
            (click)="removeTag(i)"
          ></button>
        </div>

        <div class="form-grid" style="padding: 0.75rem">
          <div class="form-field">
            <label [for]="'hotkeyTag' + i">Tag</label>
            <input
              pInputText
              type="text"
              [id]="'hotkeyTag' + i"
              formControlName="hotkey_tag"
              maxlength="8"
              class="w-full"
            />
            <small
              class="p-error"
              *ngIf="tag.get('hotkey_tag')?.hasError('required') && (tag.get('hotkey_tag')?.touched || tag.get('hotkey_tag')?.dirty)"
            >
              <strong>A tag</strong> is required
            </small>
            <small
              class="p-error"
              *ngIf="tag.get('hotkey_tag')?.hasError('maxlength')"
            >
              Tag must be 8 characters or fewer
            </small>
          </div>

          <div class="form-field">
            <label [for]="'tagDescription' + i">Description</label>
            <input
              pInputText
              type="text"
              [id]="'tagDescription' + i"
              formControlName="tag_description"
              maxlength="100"
              class="w-full"
            />
            <small
              class="p-error"
              *ngIf="tag.get('tag_description')?.hasError('required') && (tag.get('tag_description')?.touched || tag.get('tag_description')?.dirty)"
            >
              <strong>A description</strong> is required
            </small>
            <small
              class="p-error"
              *ngIf="tag.get('tag_description')?.hasError('maxlength')"
            >
              Description must be 100 characters or fewer
            </small>
          </div>
        </div>
      </article>
    </div>

    <ng-template #noTags>
      <div class="jobs-empty">
        <span>No tags added yet</span>
      </div>
    </ng-template>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Create Hotkey"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
